export const SET_ASSET = 'SET_ASSET'
export const SET_ASSET_WORKORDERS_LIST = 'SET_ASSET_WORKORDERS_LIST'
export const SET_ASSET_ATTRIBUTES = 'SET_ASSET_ATTRIBUTES'
